(function($){

  var slickOps = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
    focusOnSelect: true
  };

  //init first
  $(".condition-item").first().addClass("active");
  $(".conditions-product-slider").first().slick(slickOps);

  $(".condition-item a").on("click", function(e){
    e.preventDefault();
    var index = $(this).parent().index();
    $(".condition-item.active").removeClass("active");
    $(".conditions-product-slider.active").removeClass("active").slick("unslick");

    $(this).parent().addClass("active");
    $(".conditions-product-slider").eq(index).addClass("active").slick(slickOps);
  });


  //make pdf open in new tab
  $(".header .sub-menu a").each(function(i, el){
    var attr = $(el).attr("href");
    if(attr != undefined){
      if(attr.includes(".pdf")){
        $(el).attr("target", "_blank");
      }
    }
  });
  
  //Added to Cart Popup
  $(".popup-close").click(function() {
    $(".continue_popup").removeClass("continue_active");
  });
  
  //bundle accordion
  $('.accordion-wrap .accordion-item').on('click', function (e) {
    //$('.accordion-wrap .accordion-item.active').removeClass('active');
    var item = $(this);
    item.toggleClass('active', 1000);
  });


})(jQuery);